import { Search } from 'lucide-react';
import { useEffect, useState } from 'react';

/** Debounced search box (updates the parent 350 ms after typing stops). */
export function SearchInput({ value, onChange, placeholder }: { value: string; onChange: (v: string) => void; placeholder?: string }) {
  const [text, setText] = useState(value);
  // Follow external resets (e.g. filters cleared) without an effect.
  const [synced, setSynced] = useState(value);
  if (value !== synced) {
    setSynced(value);
    setText(value);
  }
  useEffect(() => {
    if (text === value) return;
    const t = setTimeout(() => onChange(text), 350);
    return () => clearTimeout(t);
  }, [text, value, onChange]);
  return (
    <div className="relative min-w-44 flex-1">
      <Search className="pointer-events-none absolute start-3 top-1/2 size-4 -translate-y-1/2 text-muted" />
      <input className="input ps-9" value={text} placeholder={placeholder ?? 'بحث...'} onChange={(e) => setText(e.target.value)} />
    </div>
  );
}
